import * as React from "react";
import { css } from "@emotion/core";
import { Link } from "react-router-dom";

type ArrowProps = {
  direction: "left" | "right";
};

export const Arrow = ({ direction }: ArrowProps) => (
  <div
    css={css`
      border-top: #575757 1px solid;
      border-right: #575757 1px solid;
      transform: rotate(${direction === "left" ? 225 : 45}deg);
      width: 20px;
      height: 20px;
      margin: 10px;
    `}
  />
);

type Props = {
  children?: JSX.Element | string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  to: string;
  direction: "left" | "right";
  external?: boolean;
};

export const ArrowLink = ({
  children,
  onClick,
  to,
  direction,
  external
}: Props) => {
  const _children = (
    <>
      {direction === "left" && <Arrow direction={direction} />}
      {children}
      {direction === "right" && <Arrow direction={direction} />}
    </>
  );
  const baseProps = {
    className: "arrow-link",
    onClick,
    css: css`
      display: flex;
      align-items: center;
      color: #373742;
      font-size: 16px;
    `
  };
  return external ? (
    <a
      {...{
        ...baseProps,
        href: to
      }}
    >
      {_children}
    </a>
  ) : (
    <Link
      {...{
        ...baseProps,
        to
      }}
    >
      {_children}
    </Link>
  );
};
